import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.print'),
    id: 'print',
    sidebar: [
        {
            // TODO: Se añadirán las secciones y traducciones cuando se analicen
            id: 'elementMockup',
            label: 'Mockup section',
            icon: 'far fa-star',
            routeName: 'PrintMockup',
            hasChildren: false
        }
    ]
}
